import {useEffect, useRef, useState} from 'react'

import requestService from 'mithril/request/request'

// Apparently the situation with fetch and aborting requests is still
// terrible - xhr is a better solution but with a terrible api. Mithril
// request got it right - except for error handling.
const request = requestService(window, Promise).request

export const getPlaces = (query) => {
	const [predictions, setPredictions] = useState<Array<Prediction>>([])
	const controller = useRef<XMLHttpRequest>()
	useEffect(() => {
		if (controller.current) controller.current.abort()

		request(`/api/places?query=${encodeURIComponent(query)}`, {
			config: (xhr) => (controller.current = xhr)
		}).then((res) => setPredictions(res.predictions))
	}, [query])

	return predictions
}
export type Prediction = {
	description: string
	id: string
	matched_substrings: Array<Matchedsubstring>
	place_id: string
	reference: string
	structured_formatting: Structuredformatting
	terms: Array<Term>
	types: Array<string>
}

interface Term {
	offset: number
	value: string
}

interface Structuredformatting {
	main_text: string
	main_text_matched_substrings: Array<Matchedsubstring>
	secondary_text: string
}

interface Matchedsubstring {
	length: number
	offset: number
}
